import { render, staticRenderFns } from "./QuotesSlider.vue?vue&type=template&id=14e431cc&scoped=true&"
import script from "./QuotesSlider.vue?vue&type=script&lang=js&"
export * from "./QuotesSlider.vue?vue&type=script&lang=js&"
import style0 from "./QuotesSlider.vue?vue&type=style&index=0&id=14e431cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e431cc",
  null
  
)

export default component.exports